
import { timeRangeOptions, RETURN_REASON_OPTIONS } from "@/utils/options";


const orderStatusOptions = [
    {id: 'Pending', text: '处理中'},
    {id: 'Completed', text: '已完成'},
    {id: 'Cancelled', text: '已取消'}
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            multiple: true,
            placeholder: '仓库'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '移除类型',
    prop: 'orderType',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'orderType',
        propsData: {
            options: RETURN_REASON_OPTIONS,
            placeholder: '移除类型',
        }
    }],
    defaultValue: ''
},{
    label: '订单状态',
    prop: 'orderStatus',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'orderStatus',
        propsData: {
            options: orderStatusOptions,
            placeholder: '订单状态',
        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}]
